import { Pipe, PipeTransform } from '@angular/core';
import { CatalogueService } from 'src/app/provider/catalogue.service';
import { MenuItemCatalogPriceModel } from 'src/app/views/models/menu-item-catalog-price.model';

@Pipe({
  name: 'priceFinder'
})
export class PriceFinderPipe implements PipeTransform {

  constructor(private catalogServ: CatalogueService) { }

  transform(id: number): MenuItemCatalogPriceModel {
    const PRICES = this.catalogServ.price_change$.getValue();
    const ITEMPRICE = PRICES.find(x => x.menu_item_catalog_id === id);
    return ITEMPRICE;
  }

}
